import VueTypes from 'vue-types'

export default {
  size: VueTypes.string.def(''),
  color: VueTypes.string.def(''),
  value: VueTypes.oneOfType([String, Number, Array, Object, Boolean]).def(''),
  placeholder: VueTypes.string.def(''),
  readonly: VueTypes.bool.def(false),
  disabled: VueTypes.bool.def(false),
  length: VueTypes.number.def(1000),
  tips: VueTypes.string.def(''),
  trigger: VueTypes.array.def(['input', 'blur'])
}
